import 'isomorphic-fetch';
import { getAPIDomain } from 'shared/lib/clientSettings';

/**
 * Get the client's country code from CORE-API /ip2country endpoint.
 * Check if the country is from an Arabic speaking region.
 */
export default async function isIPArabicRegion(regions: Array<string>) {
  const allowedRegions =
    regions || 
    [
      'AE', // United Arab Emirates
      'SA', // Saudi Arabia
      'OM', // Oman
      'BH', // Bahrain
      'QA', // Qatar
      'KW', // Kuwait
    ];

  const fetchDomain = getAPIDomain('US') || '';

  return fetch(`${fetchDomain}/ip2country`)
    .then(r => r.json())
    .then(r => allowedRegions.includes(r.countryCode))
    .catch(e => console.error('Error fetching country code from /ip2country endpoint: ', e));
}
